import { Activity } from 'lucide-react';

export function Logo({
  variant = 'light',
  subtitle = 'by Nine Co',
}: {
  variant?: 'light' | 'onDark';
  subtitle?: string;
}) {
  const onDark = variant === 'onDark';
  return (
    <div className="flex items-center gap-2">
      <span
        className={`grid h-9 w-9 place-items-center rounded-xl ${
          onDark ? 'bg-white/15 text-white' : 'bg-gradient-to-br from-brand to-cyanx text-white'
        }`}
      >
        <Activity size={20} aria-hidden />
      </span>
      <div className="leading-tight">
        <div
          className={`font-display text-base font-extrabold ${
            onDark ? 'text-white' : 'text-slate-900'
          }`}
        >
          Klinik Bisnis
        </div>
        <div className={`text-[10px] ${onDark ? 'text-white/70' : 'text-slate-400'}`}>{subtitle}</div>
      </div>
    </div>
  );
}
